import React, { useMemo } from 'react';
import { APITypes } from '../../../../../../../primary-record-types';
import OrganizationDetailsForm, { FormValue } from '../../../../../../shared/OrganizationDetailsForm';
import useOrganization, { useOrganizationId } from '../../../../../../../hooks/api/useOrganization';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';

export type OrganizationEditContentOwnProps = {
    organization: APITypes.organizationService.GetOrganizationMeResponse;
    onCancel: () => void;
    onUpdate: () => void;
};

export type OrganizationEditContentProps = OrganizationEditContentOwnProps;

const OrganizationEditContent: React.FC<OrganizationEditContentProps> = (props) => {
    const organizationId = useOrganizationId();
    const { isUpdatingOrganization, updateOrganization } = useOrganization({
        onOrganizationUpdate: props.onUpdate,
    });
    const initialValues = useMemo<FormValue | null>(
        () =>
            props.organization
                ? {
                      name: props.organization.organization.metadata.name,
                      description: props.organization.organization.metadata.description,
                      address1: props.organization.organization.contactDetails.address1,
                      address2: props.organization.organization.contactDetails.address2,
                      city: props.organization.organization.contactDetails.city,
                      state: props.organization.organization.contactDetails.state,
                      zipCode: props.organization.organization.contactDetails.zipCode,
                      email: props.organization.organization.contactDetails.email,
                      phoneNumber: props.organization.organization.contactDetails.phoneNumber,
                      faxNumber: props.organization.organization.contactDetails.faxNumber,
                      url: props.organization.organization.contactDetails.url,
                      avatar: {
                          type: 'not-modified',
                      },
                      logo: {
                          type: 'not-modified',
                      },
                      isPubliclyListed: props.organization.organization.isPubliclyListed,
                      brandingPrimaryColor: props.organization.organization.metadata.brandingPrimaryColor,
                      brandingSecondaryColor: props.organization.organization.metadata.brandingSecondaryColor,
                  }
                : null,
        [props.organization],
    );

    if (!initialValues) return null;

    return (
        <AnimateLoadedContent isLoading={isUpdatingOrganization}>
            {() => (
                <OrganizationDetailsForm
                    onCancel={props.onCancel}
                    onSubmit={(values) =>
                        updateOrganization({
                            ...values,
                            brandingPrimaryColor: values.brandingPrimaryColor || undefined,
                            brandingSecondaryColor: values.brandingSecondaryColor || undefined,
                        })
                    }
                    initialValues={initialValues}
                    organizationId={organizationId}
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationEditContent);
